<template>
  <div class="ParameterSetter lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="ParameterSetter-topCurve-wrapper lxn-w100">
      <CustomCurve>
      </CustomCurve>
    </div>
    <div class="ParameterSetter-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <TitleBox :titleBgColor="'blue'" bgColor="#ECECEC">
        <template v-slot:title>
          Paramter Setter
        </template>
        <template v-slot:body>
          hubUUID
          <input v-model="hubUUID" />
          <div style="height: 10px;"></div>
          nodeUUID
          <input v-model="nodeUUID" />
          <div style="height: 10px;"></div>
          parameterId
          <input v-model="parameterId" />
          <div style="height: 10px;"></div>
          valueOfChange
          <input v-model="valueOfChange" />
          <div style="height: 10px;"></div>
          typeOfAction
          <input v-model="typeOfAction" />
          <div style="height: 10px;"></div>
          delay
          <input v-model="delay" />
          <div style="height: 10px;"></div>
        </template>
      </TitleBox>
    </div>
    <div class="ParameterSetter-button lxn-margin-auto lxn-w100">
      <CustomButton @click="setParameter();" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        Set Parameter
      </CustomButton>
      <div style="height: 10px;"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE7 from '@/statics/devices/Node7/header.js'

export default {
  name: 'ParameterSetter',
  components: {
    CustomCurve,
    CustomButton,
    TitleBox,
  },
  data: function () {
    return {
      hubUUID: this.$store.state.hubs[this.$store.state.hubs.length - 1].uuid,
      nodeUUID: this.$store.state.hubs[this.$store.state.hubs.length - 1].uuid,
      parameterId: '',
      valueOfChange: '0',
      typeOfAction: '0',
      delay: '0',
    }
  },
  mounted: function () {
  },
  destroyed: function () {
  },
  watch: {
    hubUUID: function(newVal) {
      this.nodeUUID = newVal;
    }
  },
  computed: {
  },
  methods: {
    setParameter: function (freq, ch) {
      var hub = this.$store.getters.getHubByUUID(this.hubUUID);
      if(hub == -1){
        alert("hub not found!");
        return;
      }
      if(this.parameterId == ''){
        alert("enter parameter id");
        return;
      }
      this.$store.commit('setAppBusy', true);
      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: hub.psk,
        destinationUUID: hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });
      this.$store.dispatch('setNodesParameters', {
        messagingHook: messagingHook,
        hubUUID: hub.uuid,
        bodyContent: {
          nodeActions: [
            {
              nodeUUID: this.nodeUUID,
              actions: [
                {
                  parameterId: parseInt(this.parameterId),
                  valueOfChange: parseInt(this.valueOfChange),
                  typeOfAction: parseInt(this.typeOfAction),
                  timeDelay: parseInt(this.delay)
                }
              ]
            }
          ],
        }
      })
      .then( () => {
        console.log("Parameter was set successfully");
        alert("Parameter was set successfully");
      })
      .catch( response => {
        if(response.rejectCode == 2){
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
      })
      .finally( () => {
        this.$store.commit('setAppBusy', false);
      })
    },
  }
}
</script>

<style>
  .ParameterSetter-topCurve-wrapper {
    height: 200px;
  }
  .ParameterSetter-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .ParameterSetter-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
</style>
